import { useEmployerLeaveRequests, useHrInvalidate } from "@/hooks/use-hr-queries";
import { hrEmployerApi } from "@/lib/api/hr";
import { Button } from "@/components/ui/button";
import { EmptyState, Page, QueryGate, StatusBadge } from "@/components/shell/page";

export default function EmployerLeavePage() {
  const { data, isLoading, error } = useEmployerLeaveRequests();
  const invalidate = useHrInvalidate();

  return (
    <QueryGate loading={isLoading} error={error || !data ? "Could not load leave requests." : null}>
      {data && (
        <Page title="Leave requests" description="Approve or reject. The balance changes only when you approve.">
          {data.length === 0 && (
            <EmptyState title="No requests" body="New leave applications will queue here." />
          )}
          <ul className="space-y-3">
            {data.map((req: any) => (
              <li key={req.id} className="rounded-xl border bg-card p-5 shadow-sm">
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div>
                    <p className="font-medium">
                      {req.employee_name} · {req.leave_type_name}
                    </p>
                    <p className="mt-1 text-sm text-muted-foreground">
                      {req.start_date} – {req.end_date} · {req.days} days
                    </p>
                    {req.reason && <p className="mt-2 text-sm">{req.reason}</p>}
                  </div>
                  <StatusBadge status={req.status} />
                </div>
                {req.status === "pending" && (
                  <div className="mt-4 flex gap-2">
                    <Button
                      size="sm"
                      onClick={async () => {
                        await hrEmployerApi.decideLeave(req.id, "approve");
                        invalidate();
                      }}
                    >
                      Approve
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={async () => {
                        await hrEmployerApi.decideLeave(req.id, "reject");
                        invalidate();
                      }}
                    >
                      Reject
                    </Button>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </Page>
      )}
    </QueryGate>
  );
}
